import { io } from "socket.io-client";

export const saveQuestionSocketInit = (
  { questions, warnings, isPublished, isSkippable },
  newVersionCallback,
  onComplete,
  errorCallback,
  versionSavedCallback,
  progressEvent
) => {
  const socket = io(process.env.VUE_APP_SOCKET_URL, {
    path: "/quizservice/socket/save-question",
    transports: ["websocket"],
  });
  const questionsInner = [...questions];
  let finished = false;

  const fail = (err) => {
    if (finished) return;
    finished = true;
    try {
      errorCallback(err);
    } finally {
      socket.disconnect();
    }
  };

  socket.connect();

  socket.on("connect", () => {
    console.log(socket.id);
  });

  socket.on("connect_error", (err) => {
    fail(err && err.message ? err.message : "Failed to connect publish socket");
  });

  socket.on("disconnect", () => {
    console.log(socket.id);
  });

  const createNewVersion = () => {
    socket.emit("createNewVersion");
  };
  socket.on("needToCreateNewVersion", () =>
    newVersionCallback(createNewVersion)
  );
  socket.on("error", (error) => {
    fail(error || "Failed to publish quiz");
  });
  socket.on("saved", () => {
    if (finished) return;
    finished = true;
    progressEvent(100);
    onComplete();
    socket.disconnect();
  });
  socket.on("Vsaved", (data) => {
    if (finished) return;
    finished = true;
    versionSavedCallback(data);
    socket.disconnect();
  });
  socket.on("progress", (progress) => progressEvent(progress));

  const emitBatches = () => {
    let iterations = Math.ceil(questionsInner.length / 100) || 1;
    for (let i = 1; i <= iterations; i++) {
      if (questionsInner.length >= 100) {
        socket.emit("questions", {
          questions: questionsInner.splice(0, 100),
          warnings,
          isPublished,
          isSkippable,
          progress: (i / iterations) * 50,
        });
      } else {
        socket.emit("questions", {
          questions: questionsInner.splice(0, questionsInner.length),
          warnings,
          isPublished,
          isSkippable,
          progress: (i / iterations) * 50,
        });
      }
      if (questionsInner.length === 0) socket.emit("complete");
    }
  };

  // Wait until connected so first emit is not dropped (stuck "saving" with no server work)
  if (socket.connected) {
    emitBatches();
  } else {
    socket.once("connect", emitBatches);
  }
};
